/**
 * Filtro "Sin contabilizar" del listado de carpeta (vista clásica, 2026-09-24).
 *
 * Un documento está contabilizado cuando tiene las DOS cosas: el archivo de
 * contabilización y la marca verde "Contabilizado". Si le falta cualquiera,
 * sale en el filtro.
 *
 * De dónde sale cada dato en una fila (lib/folder_listing):
 *  - `full`: el doc files/{id} completo. Trae `accounting` y `accounted`; si
 *    el cajón lo parchó (patchRow) trae también `hasAccounting`, que es el
 *    vigente.
 *  - `entry` del array de la carpeta: trae `accounted` y `hasAccounting`, pero
 *    solo si se desnormalizó (lib/denormalize_file_flags). Las entradas viejas
 *    no traen `hasAccounting`: para esas hay que leer el doc, porque adivinar
 *    daría falsos "sin contabilizar".
 *
 * Módulo puro: sin React/Redux/Firestore, para poder testearlo directo.
 */

import { hasAccounting } from './accounting_refs';

/** ¿Hay que leer files/{id} para saber si esta fila está contabilizada? */
export const needsAccountingRead = (row) => {
  if (!row || row.failed || row.full) return false;
  return typeof row.entry?.hasAccounting !== 'boolean';
};

// ¿Tiene archivo de contabilización? null = no se sabe sin leer el doc.
const supportOf = (row) => {
  if (!row || row.failed) return null;
  if (row.full) {
    return typeof row.full.hasAccounting === 'boolean'
      ? row.full.hasAccounting
      : hasAccounting(row.full.accounting);
  }
  if (typeof row.entry?.hasAccounting === 'boolean') return row.entry.hasAccounting;
  return null;
};

/** ¿Le falta la contabilización o la marca? Una fila sin datos seguros no cuenta. */
export const isUnaccounted = (row) => {
  const soporte = supportOf(row);
  if (soporte === null) return false;
  const data = row.full || row.entry;
  return !(soporte && !!data.accounted);
};

/**
 * ¿Ya tiene la contabilización cargada y solo le falta la marca? Son los que
 * el botón «Marcar como contabilizados» marca de una vez (2026-10-22).
 */
export const isMarkPending = (row) => {
  if (supportOf(row) !== true) return false;
  return !(row.full || row.entry).accounted;
};

/** Solo las filas con contabilización y sin marca. No muta. */
export const markPendingRows = (rows) =>
  (Array.isArray(rows) ? rows : []).filter(isMarkPending);

/** Solo las filas sin contabilizar. No muta. */
export const filterUnaccounted = (rows) =>
  (Array.isArray(rows) ? rows : []).filter(isUnaccounted);
